import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from "react-select";
import { optionSelector } from "../../config/apiSPA.js";

/**
 * @param {{
 *   show: boolean,
 *   options?: {
 *     title: string,
 *     text: string
 *   }[],
 * onHide:()=>void,
 * submitClick:()=>{id:BigInteger,val:BigInteger,textVal:string},
 * id: BigInteger,
 * selector:string,
 * selected:BigInteger,
 * initialText:string
 * }} props
 * */

function ModalEditSelectType2({ show, onHide, submitClick = () => {}, options = {}, id = null, selector = "", selected = null, initialText = "" }) {
  const title = options.title ?? "No Title";
  const text = options.text ?? "please text here";

  const [enteredTextValue, setEnteredTextValue] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [option, setOption] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!show) return;

    const fetchOption = async () => {
      try {
        const res = await optionSelector(`/${selector}`);
        setOption(res);
        setLoading(false);
      } catch {
        setOption([]);
      }
    };

    fetchOption();
  }, [show, selector]);

  useEffect(() => {
    if (!show) setSelectedValue(null);
    if (!show) setEnteredTextValue("");
    if (!show) setLoading(true);
  }, [show]);

  useEffect(() => {
    if (!selected || option.length === 0) {
      setSelectedValue(null);
      return;
    }

    const selectedOption = option.find((opt) => opt.value === selected) || null;
    setSelectedValue(selectedOption);
  }, [selected, option]);

  useEffect(() => {
    setEnteredTextValue(initialText);
  }, [initialText]);

  const handleChange = (e) => {
    setSelectedValue(e ?? null);
  };
  const handleChangeText = (e) => {
    setEnteredTextValue(e);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <h5 className="modal-title">{title}</h5>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <p>Loading.....</p>
        ) : (
          <>
            <div className="mb-3">
              <Select value={selectedValue} onChange={handleChange} options={option} isSearchable classNamePrefix="react-select" />
            </div>

            <div className="mb-3">
              <textarea value={enteredTextValue ?? ""} onChange={(e) => handleChangeText(e.target.value)} className="form-control" placeholder="Remark" />
            </div>
            <div className="alert bg-inverse bg-opacity-15">{text}</div>
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <button type="button" disabled={!selectedValue} onClick={() => submitClick({ id, val: selectedValue.value, textVal: enteredTextValue })} className="btn btn-outline-theme">
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalEditSelectType2;
